var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g2, _path38, _path39, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1504_13613)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1504_13613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 95,
    width: 500,
    height: 403
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 95H0V498H500V95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1504_13613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.12 557.1C178.642 557.1 221.22 514.523 221.22 462C221.22 409.478 178.642 366.9 126.12 366.9C73.5973 366.9 31.0195 409.478 31.0195 462C31.0195 514.523 73.5973 557.1 126.12 557.1Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.719 479.24C471.928 479.24 487.499 463.669 487.499 444.46C487.499 425.252 471.928 409.68 452.719 409.68C433.511 409.68 417.939 425.252 417.939 444.46C417.939 463.669 433.511 479.24 452.719 479.24Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.259 475.46C380.516 475.46 436.659 419.317 436.659 350.06C436.659 280.804 380.516 224.66 311.259 224.66C242.003 224.66 185.859 280.804 185.859 350.06C185.859 419.317 242.003 475.46 311.259 475.46Z",
    fill: "#F0EFEF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 498H72.84",
    stroke: "#BCBEC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.04 498H500",
    stroke: "#BCBEC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M323.301 160.24C323.301 160.24 327.201 151.86 328.561 148.28C329.921 144.72 326.381 136.84 329.201 135.84C332.001 134.84 332.921 138.22 333.461 140.36L339.701 129.22C345.901 129.12 349.941 129.22 347.581 139.5C346.941 142.26 345.901 145.2 343.821 147.48C341.821 149.68 338.821 162.6 338.641 167.16L323.301 160.24Z",
    fill: "#F9B4A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.9 465.34L266.42 486.36C266.42 486.36 287.62 493.92 287.9 497.8L247.12 498.32L248.56 465.52L266.9 465.34Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.28 465.479L196.18 486.499C196.18 486.499 175.1 494.359 174.86 498.259L213.16 497.879L215.76 465.399L197.28 465.479Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.301 303.08C196.761 348.74 196.181 486.5 196.181 486.5L215.621 485.96C215.621 485.96 227.781 383.36 245.441 346.92L245.261 326.7L244.901 484.98L266.421 486.34C265.401 434.72 289.841 335.74 284.141 303.14C280.741 283.8 218.601 284.6 212.301 303.08Z",
    fill: "#154B84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.621 181.1L312.821 184.34L323.421 157.56C328.561 151.62 339.721 158 340.641 159.24C343.201 162.66 328.301 200.58 328.301 200.58C320.121 209.22 285.001 220.34 285.001 220.34C279.881 216.5 257.721 178.72 263.621 181.1Z",
    fill: "#D84154"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.661 308.08C196.561 319.04 294.001 318.56 288.421 304.94C286.721 300.8 283.741 280.74 285.961 257.6C288.361 232.6 292.341 211.34 285.001 201.04C282.141 197.02 268.661 184.08 263.621 181.1C259.481 178.66 214.261 180.64 208.581 206.86C206.281 217.46 212.961 229.28 214.181 247.88C215.761 271.78 211.921 302.36 206.661 308.08Z",
    fill: "#D84154"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M235.441 185.72C233.541 187.72 236.441 198.18 250.821 197.64C265.181 197.08 269.181 188.1 267.641 185.72C263.401 179.24 240.961 179.92 235.441 185.72Z",
    fill: "#154B84"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M247.78 124.02L246.74 124.06C236.2 124.5 227.76 132.94 227.36 143.48C226.98 153.28 232.08 167.7 234.6 173.2C238.24 181.12 244.12 181 244.12 181C244.14 181 238.66 183.78 238.66 186.98C243.7 195.52 255.8 196.38 261.78 188.48L263.12 186.8L264.76 145.26C265.26 133.92 259.1 124.2 247.78 124.02Z",
    fill: "#F9B4A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.72 177.34C238.72 177.34 248.08 180.64 257.44 173.2C257.44 173.2 254.38 181.5 243.5 180.96L238.72 177.34Z",
    fill: "#F48271"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.2 153.3C264.38 153.22 271.56 150.78 271.64 158.22C271.72 165.66 263.64 164.44 263.62 164.22C263.6 164.02 264.2 153.3 264.2 153.3Z",
    fill: "#F9B4A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.56 133.78C228.6 133.74 228.6 124.16 228.96 123.78C231.72 120.98 234.1 119.02 236.56 118C240.18 116.5 246.22 115.84 250.02 116.78C253.82 117.72 257.24 120.76 257.82 124.62C259.92 122.8 263.68 121.18 265.18 123.52C272.76 135.2 268.78 151.08 268.08 152.94C266.1 153 265.62 152.78 264.64 153.12C263.36 153.56 263.88 155.84 262.2 155.2C261.34 154.88 260 151.66 259.7 150.8C257.74 145.06 257.04 138.9 257.66 132.86C256.46 131.6 255 130.58 253.42 129.86L253.56 129.98C250.52 128.96 247.06 127.96 244.2 129.42C241.98 130.56 240.68 132.88 239.04 134.76C235.92 138.3 232.34 140.22 227.62 140.48C227.24 143.76 227.32 147.88 227.8 152.36L224.36 146.1V146.12C220.4 136.96 227.76 134.3 228.56 133.78Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.54 166.52C240.02 167.46 241.24 167.56 244.1 167.04C246.96 166.52 246.82 164.88 246.82 164.88C246.82 164.88 246.28 163.34 244.26 163.78C242.24 164.22 239.52 165.44 239.52 165.44C239.52 165.44 239.1 165.64 239.54 166.52Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.84 164.88C246.76 164.94 246.62 164.42 246.04 164.16C245.74 164.04 245.36 164.06 244.9 164.14C244.44 164.22 243.92 164.3 243.4 164.42C241.26 164.88 239.62 165.56 239.56 165.42C239.5 165.32 241.1 164.4 243.3 163.94C243.84 163.82 244.38 163.74 244.86 163.7C245.32 163.64 245.84 163.64 246.2 163.84C246.56 164.04 246.74 164.34 246.82 164.54C246.86 164.76 246.86 164.88 246.84 164.88Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.74 139.82C261.82 140.8 228.26 140.64 224.6 138.28C222.98 132.44 225.02 125.66 226.74 123.82C231.66 118.6 244.46 115.4 248.82 115.58C253.18 115.76 261.22 118.56 264.92 123.18C269.76 129.24 269.74 139.82 269.74 139.82Z",
    fill: "#E42230"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.304 116.679C252.328 115.939 250.764 115.287 248.81 115.222C246.857 115.157 245.253 115.704 245.228 116.444C245.204 117.184 246.768 117.836 248.721 117.901C250.675 117.966 252.279 117.419 252.304 116.679Z",
    fill: "#154B84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.02 133.34C224.02 133.34 239.96 120.44 257.96 140.34L222.9 137.14L224.02 133.34Z",
    fill: "#154B84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M234.52 133.9C224.42 134.7 215.34 137.58 213.22 143.3C210.86 149.66 220.98 138.62 229 140.44C242.46 143.48 239.8 145.1 257.96 140.36C247.42 137.76 246.22 132.98 234.52 133.9Z",
    fill: "#5274B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M234.52 133.9C224.42 134.7 215.34 137.58 213.22 143.3C210.86 149.66 220.98 138.62 229 140.44C242.46 143.48 239.8 145.1 257.96 140.36C247.42 137.76 246.22 132.98 234.52 133.9Z",
    fill: "#E42230"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M341.14 354.62L117.4 399.9L114.48 385.42L104.82 387.38L100.72 367.1L334.12 319.86L341.14 354.62Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.84 362.14L396.66 349.62C396.66 349.62 403.36 339.76 401.4 330.06C399.44 320.36 394.1 294.02 385.1 279.28C376.08 264.52 340.54 234.74 329.42 232.54C318.3 230.32 280.76 239.72 280.76 239.72C282 245.84 302.6 347.64 302.6 347.64L330.76 341.94L334.84 362.14Z",
    fill: "#7C95CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M298.779 248.06C309.839 244.92 324.579 241.06 333.739 248.58C342.899 256.1 357.359 269.24 360.739 274.36C364.119 279.48 364.419 289.22 357.299 290.66C350.179 292.1 329.419 296.3 321.999 297.8C314.579 299.3 309.019 298.66 307.619 291.8C306.239 284.92 298.779 248.06 298.779 248.06Z",
    fill: "#E5EFF9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M314.14 311.88L329.4 308.78C330.7 308.52 331.54 307.24 331.28 305.94C331.02 304.64 329.74 303.8 328.44 304.06L313.18 307.16C311.88 307.42 311.04 308.7 311.3 310C311.58 311.3 312.86 312.14 314.14 311.88Z",
    fill: "#414142"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M394.6 334.64L398.46 333.86C399.46 333.66 400.12 332.68 399.92 331.66C399.72 330.66 398.74 330 397.72 330.2L393.86 330.98C392.86 331.18 392.2 332.16 392.4 333.18C392.62 334.2 393.6 334.84 394.6 334.64Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M396.66 349.62L340.5 360.98L341.46 348.28L401.62 336.1C400.84 343.48 396.66 349.62 396.66 349.62Z",
    fill: "#7C95CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M298.779 248.06C301.399 247.32 304.239 246.54 307.139 245.88L362.519 285.84C361.759 288.2 360.119 290.08 357.299 290.64C355.339 291.04 352.379 291.64 348.939 292.34L300.439 256.28C299.459 251.42 298.779 248.06 298.779 248.06Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M338.279 294.5L302.559 266.76C302.179 264.92 301.819 263.12 301.479 261.4L343.739 293.4C341.939 293.74 340.099 294.12 338.279 294.5Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M238.738 380.929L290.174 370.517L286.138 350.582L234.703 360.994L238.738 380.929Z",
    fill: "#929497"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.745 380.929L290.181 370.517L288.879 364.088L237.444 374.5L238.745 380.929Z",
    fill: "#808184"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M236.314 368.926L287.75 358.514L286.143 350.575L234.707 360.987L236.314 368.926Z",
    fill: "#BBBDBF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M334.9 326.64C354.28 322.72 373.18 334.54 378.36 353.32L334.86 362.12L330.76 341.9L309 346.3C314 336.52 323.26 329 334.9 326.64Z",
    fill: "#BBBDBF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M342.32 397.42C361.164 397.42 376.44 382.144 376.44 363.3C376.44 344.456 361.164 329.18 342.32 329.18C323.476 329.18 308.2 344.456 308.2 363.3C308.2 382.144 323.476 397.42 342.32 397.42Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M342.32 382.74C353.056 382.74 361.76 374.037 361.76 363.3C361.76 352.564 353.056 343.86 342.32 343.86C331.583 343.86 322.88 352.564 322.88 363.3C322.88 374.037 331.583 382.74 342.32 382.74Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.12 383.16L128.84 397.58C129.44 380.7 141.5 365.78 158.8 362.28C176.1 358.78 193 367.82 200.12 383.16Z",
    fill: "#595A5C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.995 432.368C191.464 428.629 203.406 410.627 199.667 392.158C195.928 373.689 177.926 361.747 159.457 365.486C140.988 369.225 129.046 387.227 132.785 405.696C136.524 424.165 154.526 436.107 172.995 432.368Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.22 418.38C176.957 418.38 185.66 409.677 185.66 398.94C185.66 388.204 176.957 379.5 166.22 379.5C155.484 379.5 146.78 388.204 146.78 398.94C146.78 409.677 155.484 418.38 166.22 418.38Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9003 372.615L296.253 332.462L273.992 222.495L75.6398 262.647L97.9003 372.615Z",
    fill: "#7C95CC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.887 331.035L292.611 330.079L271.613 226.345L266.889 227.302L287.887 331.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.382 332.552L285.106 331.596L264.108 227.862L259.384 228.819L280.382 332.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.881 334.089L277.605 333.133L256.607 229.399L251.883 230.355L272.881 334.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.396 335.602L270.12 334.646L249.121 230.912L244.397 231.868L265.396 335.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.891 337.12L262.615 336.164L241.617 232.43L236.892 233.386L257.891 337.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.386 338.637L255.11 337.681L234.112 233.947L229.388 234.903L250.386 338.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.881 340.154L247.605 339.198L226.607 235.464L221.883 236.42L242.881 340.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.376 341.671L240.101 340.715L219.102 236.981L214.378 237.937L235.376 341.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.872 343.188L232.596 342.232L211.597 238.498L206.873 239.454L227.872 343.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.367 344.705L225.091 343.749L204.092 240.015L199.368 240.972L220.367 344.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.862 346.223L217.586 345.267L196.587 241.533L191.863 242.489L212.862 346.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.376 347.736L210.1 346.78L189.101 243.046L184.377 244.002L205.376 347.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.871 349.253L202.595 348.297L181.596 244.563L176.872 245.519L197.871 349.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.366 350.77L195.09 349.814L174.091 246.08L169.367 247.036L190.366 350.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.861 352.288L187.585 351.332L166.586 247.598L161.862 248.554L182.861 352.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.36 353.824L180.084 352.868L159.085 249.134L154.361 250.091L175.36 353.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.855 355.342L172.579 354.385L151.58 250.651L146.856 251.608L167.855 355.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.35 356.859L165.074 355.902L144.076 252.169L139.351 253.125L160.35 356.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.845 358.376L157.569 357.419L136.571 253.686L131.847 254.642L152.845 358.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.34 359.893L150.064 358.937L129.066 255.203L124.342 256.159L145.34 359.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.855 361.406L142.579 360.45L121.58 256.716L116.856 257.673L137.855 361.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35 362.924L135.074 361.967L114.076 258.234L109.351 259.19L130.35 362.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.844 364.441L127.568 363.484L106.57 259.751L101.846 260.707L122.844 364.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.339 365.958L120.063 365.001L99.0648 261.268L94.3407 262.224L115.339 365.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.835 367.475L112.559 366.519L91.5599 262.785L86.8359 263.741L107.835 367.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33 368.992L105.054 368.036L84.0551 264.302L79.331 265.259L100.33 368.992Z",
    fill: "white"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M220.641 256.16C220.641 256.16 224.121 264.72 225.801 268.16C227.481 271.6 235.661 274.38 234.461 277.1C233.281 279.84 230.181 278.2 228.241 277.14L232.141 289.3C227.981 293.9 225.161 296.8 219.241 288.06C217.661 285.72 216.221 282.96 215.961 279.88C215.721 276.9 208.321 265.92 205.101 262.68L220.641 256.16Z",
    fill: "#F9B4A6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M217.4 213.26C217.26 213.68 215.76 234.28 215.76 234.28L227.76 265.34L214 274.5C214 274.5 182.24 237.04 185.68 229.34C190.7 218.08 217 193.92 217 193.92L217.4 213.26Z",
    fill: "#D84154"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.54 96.8401C138.32 96.1201 138.58 95.6401 139.34 95.4201L154.32 90.9401C155.06 90.7201 155.52 90.9801 155.74 91.7001L171.74 160.26C171.96 160.98 171.7 161.46 170.98 161.68L164.32 163.68C163.58 163.9 163.1 163.66 162.88 162.92L138.54 96.8401ZM164.78 169.38C164.64 168.92 164.68 168.58 164.86 168.3C165.06 168.04 165.28 167.86 165.54 167.78L172.08 165.82C172.32 165.74 172.54 165.74 172.72 165.78C172.9 165.82 173.06 165.9 173.18 166C173.3 166.1 173.4 166.2 173.48 166.34C173.56 166.46 173.6 166.56 173.62 166.64L175.6 173.24C175.68 173.48 175.68 173.7 175.64 173.86C175.58 174.04 175.52 174.18 175.4 174.32C175.3 174.44 175.18 174.54 175.06 174.6C174.94 174.66 174.84 174.72 174.74 174.74L168.2 176.7C168.14 176.72 168.02 176.74 167.9 176.74C167.76 176.74 167.62 176.72 167.48 176.68C167.32 176.64 167.18 176.56 167.04 176.44C166.9 176.32 166.8 176.14 166.72 175.9L164.78 169.38Z",
    fill: "#D84154"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1504_13613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverNotFound);
export default __webpack_public_path__ + "static/media/driver-not-found.da50585b88483eadd733991333a98548.svg";
export { ForwardRef as ReactComponent };